<template>
  <header class="cesco-header" @mouseleave="onMouseLeave">
    <nav>
      <div>
        <div class="logo-box">
          <img src="@/assets/images/icons/logo.svg" alt="CESCO Logo" @click="router.push('/')" />
        </div>

        <div class="pc-header-menu">
          <ul class="nav-ul">
            <li id="li-solution" :class="{ 'li-active': naviCurrent === 'solution' }" @mouseover.self="onMouseOver">
              <a href="#" aria-current="page">Solution</a>
            </li>
            <li id="li-location" :class="{ 'li-active': naviCurrent === 'location' }" @mouseover.self="onMouseOver">
              <router-link to="/solution/place/list">Business sectors</router-link>
            </li>
            <li id="li-members" :class="{ 'li-active': naviCurrent === 'members' }" @mouseover.self="onMouseOver">
              <router-link to="/homepage/info/whyMembers">Members</router-link>
            </li>
            <li id="li-contact" :class="{ 'li-active': naviCurrent === 'contact' }" @mouseover.self="onMouseOver">
              <router-link to="/contact">Contact</router-link>
            </li>
          </ul>
        </div>

        <div class="mb-header-icons">
          <button
            data-collapse-toggle="navbar-default"
            type="button"
            aria-controls="navbar-default"
            aria-expanded="false"
            id="hamburger"
            :class="{ open: isActive }"
            @click="isActive = !isActive"
          >
            <img src="@/assets/images/icons/Menu-28.svg" />
            <img src="@/assets/images/icons/Close-28.svg" />
          </button>

          <div class="header-lang-dropdown" ref="langDropdown">
            <div @click="langListActive = !langListActive">
              <p>EN</p>
              <img src="@/assets/images/icons/Down_b.svg" :class="{ selected: langListActive }" />
            </div>

            <ul :class="{ selected: langListActive }">
              <li><a href="https://www.cesco.co.kr/" target="_blank">KR</a></li>
              <li><a href="https://cescovietnam.com.vn/" target="_blank">VN</a></li>
              <li><a href="https://cesco.cn/" target="_blank">CN</a></li>
            </ul>
          </div>
        </div>
      </div>
    </nav>

    <div class="dropdown-area">
      <div id="li-solution-dropdown" :class="['me-dropdown', naviCurrent === 'solution' ? '' : 'hidden']">
        <div>
          <div class="sec">
            <b>Pest Control</b>
            <ul>
              <li>
                <router-link class="nav-link" to="/solution/service/total">
                  Integrated Pest Management Solution
                  <br />
                  (IPM Solution)
                </router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/service/fly">
                  Flying Insect Control Solution
                  <br />
                  (FIC Solution)
                </router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/service/bedbug">Bed bug Control Solution</router-link>
              </li>
            </ul>
          </div>

          <div class="sec">
            <b>Viruscare</b>
            <ul>
              <li>
                <router-link class="nav-link" to="/solution/service/virusCare">Viruscare Solution</router-link>
              </li>
            </ul>
          </div>

          <div class="sec">
            <b>Environmental Appliances</b>
            <ul>
              <li>
                <router-link class="nav-link" to="/solution/service/airSterile">Air Sterilizer</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/service/dualcare">Air Sterilizer Purifier</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/service/air">Air Purifier</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/service/water">Water Purifier</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/service/scent">Fragrance Solution Airperfume</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="li-location--dropdown" :class="['me-dropdown', naviCurrent === 'location' ? '' : 'hidden']">
        <div>
          <div class="sec">
            <ul>
              <li>
                <router-link class="nav-link" to="/solution/place/home">Homes</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/place/restaurant">Dining Establishments</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/place/retail">Distribution Logistics</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/place/edu">Educational Facilities</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/place/building">Building Facilities</router-link>
              </li>
            </ul>
          </div>
          <div class="sec">
            <ul>
              <li>
                <router-link class="nav-link" to="/solution/place/service">Service Facilities</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/place/culture">Cultural Facilities</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/place/medical">Medical Facilities</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/place/hotel">Deluxe Hotels/Resorts</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/place/motel">General Hotels/Hostels</router-link>
              </li>
            </ul>
          </div>
          <div class="sec">
            <ul>
              <li>
                <router-link class="nav-link" to="/solution/place/foodfactory">Food Manufacturing</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/place/factory">Manufacturing Plant</router-link>
              </li>
              <li>
                <router-link class="nav-link" to="/solution/place/storage">Warehouse Facilities</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-area-mb">
      <div :class="{ hidden: !isActive }">
        <div class="mb-dropdown-item">
          <button :class="['nav-button', mobileList[0].state ? 'nav-open' : '']" @click="handleListClick(0)">
            <b>Solution</b>
            <img src="@/assets/images/icons/nav-down.svg" />
          </button>
          <div class="content-layout">
            <div>
              <b class="tit">Pest Control</b>
              <ul>
                <li>
                  <router-link class="nav-link" to="/solution/service/total">Integrated Pest Management Solution <br />(IPM Solution) </router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/service/fly">Flying Pest Control Solution(FIC Solution)</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/service/bedbug">Bed bug Control Solution</router-link>
                </li>
              </ul>
            </div>
            <div>
              <b class="tit">Viruscare</b>
              <ul>
                <li>
                  <router-link class="nav-link" to="/solution/service/virusCare">Viruscare Solution</router-link>
                </li>
              </ul>
            </div>
            <div>
              <b class="tit">Environmental Appliances</b>
              <ul>
                <li>
                  <router-link class="nav-link" to="/solution/service/airSterile">Air Sterilizer</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/service/dualcare">Air Sterilizer Purifier</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/service/air">Air Purifier</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/service/water">Water Purifier</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/service/scent">Fragrance Solution Airperfume</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="mb-dropdown-item">
          <button :class="['nav-button', mobileList[1].state === true ? 'nav-open' : '']" @click="handleListClick(1)">
            <b><router-link class="nav-link" to="/solution/place/list">Business sectors</router-link></b>
            <img src="@/assets/images/icons/nav-down.svg" />
          </button>
          <div class="content-layout">
            <div>
              <ul>
                <li>
                  <router-link class="nav-link" to="/solution/place/home">Homes</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/place/restaurant">Dining Establishments</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/place/retail">Distribution Logistics</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/place/edu">Educational Facilities</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/place/building">Building Facilities</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/place/service">Service Facilities</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/place/culture">Cultural Facilities</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/place/medical">Medical Facilities</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/place/hotel">Deluxe Hotels/Resorts</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/place/motel">General Hotels/Hostels</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/place/foodfactory">Food Manufacturing</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/place/factory">Manufacturing Plant</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/solution/place/storage">Warehouse Facilities</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="mb-dropdown-item">
          <button class="nav-button">
            <b> <router-link class="nav-link" to="/homepage/info/whyMembers">Members</router-link></b>
          </button>
        </div>
        <!-- <div class="mb-dropdown-item">
          <button class="nav-button">
            <b>Broshure</b>
          </button>
        </div> -->
        <div class="mb-dropdown-item">
          <button class="nav-button">
            <b><router-link class="nav-link" to="/contact">Contact</router-link></b>
          </button>
        </div>
        <div class="nav-lang">
          <a href="https://www.cesco.co.kr/" target="_blank">KR</a>
          <a href="https://cescovietnam.com.vn/" target="_blank">VN</a>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

const naviCurrent = ref('')
const isActive = ref(false)
const mobileList = ref([{ state: false }, { state: false }, { state: false }])
const langListActive = ref(false)
const langDropdown = ref(null)

const onMouseOver = e => {
  const id = e.target.id
  naviCurrent.value = id.replace('li-', '')
}

const onMouseLeave = () => {
  naviCurrent.value = ''
}

const handleListClick = i => {
  mobileList.value[i].state = !mobileList.value[i].state
}

onMounted(() => {
  if (!langListActive.value) {
    document.addEventListener('click', handleClick)
  } else {
    document.removeEventListener('click', handleClick)
  }
})

const handleClick = e => {
  if (langDropdown.value == null) {
    return
  } else if (!langDropdown.value.contains(e.target)) {
    langListActive.value = false
  }
}

watch(
  () => route.path,
  () => {
    naviCurrent.value = ''
    isActive.value = false
  }
)

watch(isActive, value => {
  value ? (document.body.style.overflow = 'hidden') : document.body.style.removeProperty('overflow')
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/header.scss';
</style>
